import {
  Box,
  Button,
  Center,
  Flex,
  HStack,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Portal,
  Tab,
  Table,
  TableContainer,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { RiSearch2Line } from "react-icons/ri";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import { CreateDisciplineModal } from "../../../components/admin/programs/CreateDisciplineModal";
import { CreateSpecializationModal } from "../../../components/admin/programs/CreateSpecializationModal";
import { DeleteDisciplineModal } from "../../../components/admin/programs/DeleteDisciplineModal";
import { DeleteSpecializationModal } from "../../../components/admin/programs/DeleteSpecializationModal";
import Loading from "../../../components/common/Loading";
import delete_vector from "../../../img/deleteVectorRed.svg";
import { IProgramModule } from "../../../models/admin/programs/module.model";
import programsService from "../../../services/program_service/programs.service";

const AdminProgramDisciplineNSpecialization = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [deleteDiscipline, setdeleteDiscipline] = useState(false);
  const [isDiscipline, setisDiscipline] = useState(false);
  const [disciplineId, setdisciplineId] = useState("");
  const [programDiscipline, setprogramDiscipline] = useState<IProgramModule[]>(
    []
  );
  const [fileteredprogramDiscipline, setFilteredprogramDiscipline] = useState<
    IProgramModule[]
  >([]);
  const [deleteSpecialization, setdeleteSpecialization] = useState(false);
  const [isSpecialization, setisSpecialization] = useState(false);
  const [specializationId, setspecializationId] = useState("");
  const [programSpecialization, setprogramSpecialization] = useState<
    IProgramModule[]
  >([]);
  const [filteredprogramSpecialization, setFilteredprogramSpecialization] =
    useState<IProgramModule[]>([]);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);

  useEffect(() => {
    programsService.getDisciplines().then((res) => {
      setprogramDiscipline(res.data);
      setFilteredprogramDiscipline(res.data);
      setLoading(false);
    });
    programsService.getSpecializations().then((res) => {
      setprogramSpecialization(res.data);
      setFilteredprogramSpecialization(res.data);
      setLoading(false);
    });
  }, [reload]);

  const openDeleteDisciplineModal = async (id: string) => {
    setisDiscipline(false);
    setisSpecialization(false);
    setdisciplineId(id);
    setdeleteDiscipline(true);
    setdeleteSpecialization(false);
    onOpen();
  };
  const openCreateDisciplineModal = async () => {
    setisDiscipline(true);
    setisSpecialization(false);
    setdeleteDiscipline(false);
    setdeleteSpecialization(false);
    onOpen();
  };
  const openDeleteSpecializationModal = async (id: string) => {
    setisDiscipline(false);
    setisSpecialization(false);
    setspecializationId(id);
    setdeleteDiscipline(false);
    setdeleteSpecialization(true);
    onOpen();
  };

  const openCreateSpecializationModal = async () => {
    setisDiscipline(false);
    setisSpecialization(true);
    setdeleteDiscipline(false);
    setdeleteSpecialization(false);
    onOpen();
  };

  const reloadData = () => {
    setReload(!reload);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredprogramDiscipline(programDiscipline);
    } else {
      if (programDiscipline) {
        const filtered = programDiscipline.filter((each: any) =>
          each.name.toLowerCase().includes(searchTerm)
        );
        setFilteredprogramDiscipline(filtered);
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };
  const handleSearchSpecialization = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredprogramSpecialization(programSpecialization);
    } else {
      if (programSpecialization) {
        const filtered = programSpecialization.filter((each: any) =>
          each.name.toLowerCase().includes(searchTerm)
        );
        setFilteredprogramSpecialization(filtered);
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box>
          <Flex
            minHeight={"100vh"}
            height={"auto"}
            boxSizing="border-box"
            maxWidth={"100hw"}
          >
            <Box
              width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
              position="relative"
              top="0"
              left="0"
              zIndex="100"
            >
              <AdminSidebar />
            </Box>

            <Box width={"100%"}>
              <AdminDashboardHeader />
              <Box
                pt="30px"
                px={["20px", "30px"]}
                width={"100%"}
                bg="#F9F8F8"
                height={"auto"}
                minHeight={"95vh"}
                maxHeight={"95vh"}
                overflowX={"scroll"}
                className="scroll-hidden"
              >
                <Flex
                  justifyContent="space-between"
                  alignItems="center"
                  py="26px"
                >
                  <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                    Discipline & Area of Specialization
                  </Box>
                </Flex>
                <Tabs isFitted variant="enclosed">
                  <TabList bg={"white"} mb="1em">
                    <Tab fontSize={["13px", "14px", "15px", "16px"]}>
                      Discipline
                    </Tab>
                    <Tab fontSize={["13px", "14px", "15px", "16px"]}>
                      Area of Specialization
                    </Tab>
                  </TabList>
                  <TabPanels>
                    <TabPanel>
                      <Box>
                        <Flex py="15px" justifyContent="space-between">
                          <InputGroup
                            color="brand.subtitle"
                            bg="white"
                            width={["100%", "100%", "50%", "30%"]}
                            mr="20px"
                          >
                            <Input
                              height="40px"
                              placeholder="Search discipline"
                              onChange={(e) => handleSearchChange(e)}
                              fontSize={12}
                              size="sm"
                            />
                            <InputRightElement
                              pointerEvents="none"
                              children={
                                <RiSearch2Line color="red" size="0.9rem" />
                              }
                            />
                          </InputGroup>
                          <HStack>
                            <Button
                              onClick={() => {
                                openCreateDisciplineModal();
                              }}
                              fontSize={12}
                              colorScheme="red"
                              size={"md"}
                              borderRadius={"2px"}
                              p="7px"
                            >
                              Add discipline
                            </Button>
                          </HStack>
                        </Flex>
                        <Box width="100%">
                          <TableContainer>
                            <Table variant="simple">
                              <Thead mb="10px">
                                <Tr
                                  pb="10px"
                                  borderBottom="1px solid"
                                  borderColor="#D5D5D5"
                                >
                                  <Th textTransform="none">Discipline</Th>
                                  <Th textTransform="none">Discipline Code</Th>
                                  <Th textTransform="none">Options</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {fileteredprogramDiscipline?.map(
                                  (each, index) => (
                                    <Tr key={index} bg="white">
                                      <Td>
                                        <HStack spacing="10px">
                                          <Text
                                            fontWeight="600"
                                            textTransform="capitalize"
                                            fontSize="16px"
                                            color="#616161"
                                          >
                                            {each.name}
                                          </Text>
                                        </HStack>
                                      </Td>

                                      <Td>{each.code}</Td>

                                      <Td>
                                        <HStack>
                                          <Center
                                            border="1px solid"
                                            borderRadius="10px"
                                            onClick={() => {
                                              openDeleteDisciplineModal(
                                                each.id.toString()
                                              );
                                            }}
                                            cursor={"pointer"}
                                            borderColor="#E5E5E5"
                                            width="30px"
                                            height="30px"
                                          >
                                            <Image
                                              src={delete_vector}
                                              width="18px"
                                              height="18px"
                                            />
                                          </Center>
                                        </HStack>
                                      </Td>
                                    </Tr>
                                  )
                                )}
                              </Tbody>
                            </Table>
                          </TableContainer>
                        </Box>
                      </Box>
                    </TabPanel>
                    <TabPanel>
                      <Box>
                        <Flex py="15px" justifyContent="space-between">
                          <InputGroup
                            color="brand.subtitle"
                            bg="white"
                            width={["100%", "100%", "50%", "30%"]}
                            mr="20px"
                          >
                            <Input
                              height="40px"
                              placeholder="Search specialization"
                              onChange={(e) => handleSearchSpecialization(e)}
                              fontSize={12}
                              size="sm"
                            />
                            <InputRightElement
                              pointerEvents="none"
                              children={
                                <RiSearch2Line color="red" size="0.9rem" />
                              }
                            />
                          </InputGroup>
                          <HStack>
                            <Button
                              onClick={() => {
                                openCreateSpecializationModal();
                              }}
                              fontSize={12}
                              colorScheme="red"
                              size={"md"}
                              borderRadius={"2px"}
                              p="7px"
                            >
                              Add specialization
                            </Button>
                          </HStack>
                        </Flex>
                        <Box width="100%">
                          <TableContainer>
                            <Table variant="simple">
                              <Thead mb="10px">
                                <Tr
                                  pb="10px"
                                  borderBottom="1px solid"
                                  borderColor="#D5D5D5"
                                >
                                  <Th textTransform="none">
                                    Area of specialization
                                  </Th>
                                  <Th textTransform="none">
                                    Specialization Code
                                  </Th>
                                  <Th textTransform="none">Options</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {filteredprogramSpecialization?.map(
                                  (each, index) => (
                                    <Tr key={index} bg="white">
                                      <Td>
                                        <HStack spacing="10px">
                                          <Text
                                            fontWeight="600"
                                            textTransform="capitalize"
                                            fontSize="16px"
                                            color="#616161"
                                          >
                                            {each.name}
                                          </Text>
                                        </HStack>
                                      </Td>

                                      <Td>{each.code}</Td>

                                      <Td>
                                        <HStack>
                                          <Center
                                            border="1px solid"
                                            borderRadius="10px"
                                            onClick={() => {
                                              openDeleteSpecializationModal(
                                                each.id.toString()
                                              );
                                            }}
                                            cursor={"pointer"}
                                            borderColor="#E5E5E5"
                                            width="30px"
                                            height="30px"
                                          >
                                            <Image
                                              src={delete_vector}
                                              width="18px"
                                              height="18px"
                                            />
                                          </Center>
                                        </HStack>
                                      </Td>
                                    </Tr>
                                  )
                                )}
                              </Tbody>
                            </Table>
                          </TableContainer>
                        </Box>
                      </Box>
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Box>
            </Box>
          </Flex>

          {deleteDiscipline && (
            <Portal>
              {" "}
              <DeleteDisciplineModal
                isOpenDelete={isOpen}
                onCloseDelete={onClose}
                disciplineId={disciplineId}
                updateRecord={reloadData}
              />{" "}
            </Portal>
          )}

          {isDiscipline && (
            <Portal>
              {" "}
              <CreateDisciplineModal
                isOpenModule={isOpen}
                onClosed={onClose}
                isDiscipline={isDiscipline}
                reload={reloadData}
              />{" "}
            </Portal>
          )}

          {deleteSpecialization && (
            <Portal>
              {" "}
              <DeleteSpecializationModal
                isOpenDelete={isOpen}
                onCloseDelete={onClose}
                specializationId={specializationId}
                updateRecord={reloadData}
              />{" "}
            </Portal>
          )}

          {isSpecialization && (
            <Portal>
              {" "}
              <CreateSpecializationModal
                isOpenModule={isOpen}
                onClosed={onClose}
                isSpecial={isSpecialization}
                reload={reloadData}
              />{" "}
            </Portal>
          )}
        </Box>
      )}
    </>
  );
};

export default AdminProgramDisciplineNSpecialization;
